import { useCallback } from "react";
import { useLanguage } from "../context/LanguageContext";
import enCommon from "../locales/en/common.json";

function resolveStringTranslation(source, keys) {
  if (!source || typeof source !== "object") return undefined;

  let value = source;
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) return undefined;
  }

  return typeof value === "string" ? value : undefined;
}

export const useTranslation = () => {
  const { translations } = useLanguage();

  const interpolate = (template, vars) => {
    if (!vars || typeof template !== "string") return template;
    return Object.entries(vars).reduce(
      (str, [name, val]) => str.replace(new RegExp(`\\{\\{${name}\\}\\}`, "g"), String(val ?? "")),
      template
    );
  };

  const t = useCallback(
    (key, fallback = "", vars) => {
      const keys = key.split(".");
      const localized = resolveStringTranslation(translations, keys);
      if (localized !== undefined) {
        return interpolate(localized, vars);
      }

      const english = resolveStringTranslation(enCommon, keys);
      if (english !== undefined) {
        return interpolate(english, vars);
      }

      if (process.env.NODE_ENV === "development") {
        console.warn(`Translation key "${key}" not found`);
      }
      return interpolate(fallback || key, vars);
    },
    [translations]
  );

  return { t };
};
